import { Component } from '@angular/core';

/**
 * Account & filters guide (/docs/account-filters) what the
 * account-scoped badge on a request parameter means for callers with and
 * without a linked Cikisi client. Split out of the old single /docs
 * mega-page (see docs/overview/docs.ts) so it has its own route.
 */
@Component({
  selector: 'app-docs-account-filters',
  standalone: false,
  templateUrl: './docs-account-filters.html',
})
export class DocsAccountFilters {}
